import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { cursorMaker } from 'utils/cursorMaker';
import { IPageUrl } from 'types';

interface pageDate {
  [key: string]: string | null | undefined;
}

export type ActivityState = {
  allActivities: any;
  activities: any;
  newlyAddedActivities: any;
  nextActivityUrl: IPageUrl;
  prevActivityUrl: IPageUrl;
  nextActivityDate: pageDate;
  prevActivityDate: pageDate;
  activityPrevNextGroup: any;
  newPrevActivityId: any;
  newNextActivityId: any;
  activityPageLoaded: any;
};

const initialState: ActivityState = {
  allActivities: {},
  activities: {},
  newlyAddedActivities: {},
  nextActivityUrl: {},
  prevActivityUrl: {},
  nextActivityDate: {},
  prevActivityDate: {},
  activityPrevNextGroup: {},
  newPrevActivityId: {},
  newNextActivityId: {},
  activityPageLoaded: {}
};
const pageSize = Number(process.env.REACT_APP_PAGE_SIZE) || 5;
const pageKeepSize = Number(process.env.REACT_APP_ACTIVITY_PAGE_KEEP_SIZE) || 100;

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    setActivities(state, action) {
      if (!state.activities[action.payload.key]) {
        state.activities[action.payload.key] = [];
      }
      if (!state.allActivities[action.payload.key]) {
        state.allActivities[action.payload.key] = [];
      }
      if (action.payload.data.next_date) {
        if (
          state.nextActivityDate[action.payload.key] &&
          new Date(action.payload.data.next_date).getTime() >
            new Date(state.nextActivityDate[action.payload.key] as string).getTime()
        ) {
          state.nextActivityDate[action.payload.key] = action.payload.data.next_date;
          state.nextActivityUrl[action.payload.key] = action.payload.data.links.next;
        }
      } else {
        state.nextActivityDate[action.payload.key] = null;
        state.nextActivityUrl[action.payload.key] = null;
      }
      if (action.payload.data.previous_date) {
        if (state.prevActivityDate[action.payload.key]) {
          if (
            new Date(action.payload.data.previous_date).getTime() <
            new Date(state.prevActivityDate[action.payload.key] as string).getTime()
          ) {
            state.prevActivityDate[action.payload.key] = action.payload.data.previous_date;
            state.prevActivityUrl[action.payload.key] = action.payload.data.links.previous;
          }
        } else {
          if (action.payload.scrollToTop || action.payload.scrollToTop === undefined) {
            state.prevActivityDate[action.payload.key] = action.payload.data.previous_date;
            state.prevActivityUrl[action.payload.key] = action.payload.data.links.previous;
          } else {
            state.prevActivityDate[action.payload.key] = null;
            state.prevActivityUrl[action.payload.key] = null;
          }
        }
      } else {
        state.prevActivityDate[action.payload.key] = null;
        state.prevActivityUrl[action.payload.key] = null;
      }
      if (!state.activityPrevNextGroup[action.payload.key]) {
        state.activityPrevNextGroup[action.payload.key] = [];
      }

      // find group to extend
      const groupIndex = state.activityPrevNextGroup[action.payload.key].findIndex(
        (groupData: any) =>
          groupData.prevActivityDate === state.prevActivityDate[action.payload.key] ||
          groupData.nextActivityDate === state.nextActivityDate[action.payload.key]
      );
      // if (groupIndex !== -1) extend the group
      const newActivityPrevNextGroup = [];
      const newlyAddedActivities = action.payload.data.results.reverse();
      if (!state.newPrevActivityId[action.payload.key] && !state.newNextActivityId[action.payload.key]) {
        state.newPrevActivityId[action.payload.key] = newlyAddedActivities?.[0]?.event_id;
        state.newNextActivityId[action.payload.key] = newlyAddedActivities?.[newlyAddedActivities.length - 1]?.event_id;
      } else {
        if (action.payload.scrollToTop) {
          state.newPrevActivityId[action.payload.key] = newlyAddedActivities?.[0]?.event_id;
        } else {
          state.newNextActivityId[action.payload.key] =
            newlyAddedActivities?.[newlyAddedActivities.length - 1]?.event_id;
        }
      }
      const newItem = {
        prevActivityDate: state.prevActivityDate[action.payload.key],
        prevActivityUrl: state.prevActivityUrl[action.payload.key],
        nextActivityDate: state.nextActivityDate[action.payload.key],
        nextActivityUrl: state.nextActivityUrl[action.payload.key]
      };
      if (groupIndex !== -1) {
        state.activityPrevNextGroup[action.payload.key].splice(groupIndex, 1);
      }
      for (let i = 0; i < state.activityPrevNextGroup[action.payload.key].length; i++) {
        if (
          ((newItem.prevActivityDate &&
            new Date(state.activityPrevNextGroup[action.payload.key][i].prevActivityDate).getTime() >=
              new Date(newItem.prevActivityDate).getTime()) ||
            !newItem.prevActivityDate) &&
          newItem.nextActivityDate &&
          new Date(state.activityPrevNextGroup[action.payload.key][i].prevActivityDate).getTime() <=
            new Date(newItem.nextActivityDate).getTime()
        ) {
          if (
            new Date(state.activityPrevNextGroup[action.payload.key][i].nextActivityDate).getTime() >
            new Date(newItem.nextActivityDate).getTime()
          ) {
            newItem.nextActivityDate = state.activityPrevNextGroup[action.payload.key][i].nextActivityDate;
            newItem.nextActivityUrl = state.activityPrevNextGroup[action.payload.key][i].nextActivityUrl;
          }
        } else if (
          ((newItem.prevActivityDate &&
            new Date(state.activityPrevNextGroup[action.payload.key][i].prevActivityDate).getTime() <
              new Date(newItem.prevActivityDate).getTime()) ||
            !state.activityPrevNextGroup[action.payload.key][i].prevActivityDate) &&
          ((newItem.prevActivityDate &&
            new Date(state.activityPrevNextGroup[action.payload.key][i].nextActivityDate).getTime() >
              new Date(newItem.prevActivityDate).getTime()) ||
            !state.activityPrevNextGroup[action.payload.key][i].nextActivityDate)
        ) {
          newItem.prevActivityDate = state.activityPrevNextGroup[action.payload.key][i].prevActivityDate;
          newItem.prevActivityUrl = state.activityPrevNextGroup[action.payload.key][i].prevActivityUrl;
          if (
            newItem.nextActivityDate &&
            new Date(newItem.nextActivityDate).getTime() <
              new Date(state.activityPrevNextGroup[action.payload.key][i].nextActivityDate).getTime()
          ) {
            newItem.nextActivityDate = state.activityPrevNextGroup[action.payload.key][i].nextActivityDate;
            newItem.nextActivityUrl = state.activityPrevNextGroup[action.payload.key][i].nextActivityUrl;
          }
        } else {
          newActivityPrevNextGroup.push(state.activityPrevNextGroup[action.payload.key][i]);
        }
      }
      const allActivities = _.uniqBy(
        [...state.allActivities[action.payload.key], ...newlyAddedActivities],
        (o) => o.event_id
      ).sort((objA: any, objB: any) => new Date(objA.date_added).getTime() - new Date(objB.date_added).getTime());

      const filteredActivities = allActivities.filter((activity: any) => {
        if (newItem.nextActivityDate && newItem.prevActivityDate) {
          return (
            new Date(activity.date_added).getTime() > new Date(newItem.prevActivityDate as string).getTime() &&
            new Date(activity.date_added).getTime() < new Date(newItem.nextActivityDate as string).getTime()
          );
        } else if (newItem.nextActivityDate) {
          return new Date(activity.date_added).getTime() < new Date(newItem.nextActivityDate as string).getTime();
        } else if (newItem.prevActivityDate) {
          return new Date(activity.date_added).getTime() > new Date(newItem.prevActivityDate as string).getTime();
        } else {
          return true;
        }
      });

      const serializedWorkspaceState = localStorage.getItem('workspaces') || '[]';
      const workpaceState = JSON.parse(serializedWorkspaceState);
      const lastActiveWorkspace = localStorage.getItem('last-active:workspace');
      const sessionWorkspace = sessionStorage.getItem('workspace') || lastActiveWorkspace;
      const activeWorkspace = workpaceState.find((workspace: any) => workspace.workspace_id === sessionWorkspace);

      let newActivities = null as any;
      if (filteredActivities.length > pageKeepSize) {
        if (action.payload.scrollToTop) {
          newActivities = filteredActivities.slice(0, pageKeepSize);
          state.prevActivityDate[action.payload.key] = newItem.prevActivityDate;
          state.prevActivityUrl[action.payload.key] = newItem.prevActivityUrl;
          state.nextActivityDate[action.payload.key] = filteredActivities[pageKeepSize].date_added;
          state.nextActivityUrl[action.payload.key] = `${activeWorkspace?.url ? `${activeWorkspace.url}/` : ''}${`${
            action.payload.key === 'home'
              ? 'api/users/vod-activities/'
              : `api/channels/${action.payload.key}/activities/`
          }`}?cursor=${window.btoa(
            cursorMaker(new Date(state.nextActivityDate[action.payload.key] as string), false)
          )}&page_size=${pageSize}`;
          state.newNextActivityId[action.payload.key] = newActivities[pageKeepSize - 1].event_id;
          if (!state.prevActivityUrl[action.payload.key]) {
            state.newPrevActivityId[action.payload.key] = newActivities[0].event_id;
          }
          newItem.nextActivityDate = state.nextActivityDate[action.payload.key];
          newItem.nextActivityUrl = state.nextActivityUrl[action.payload.key];
        } else {
          newActivities = filteredActivities.slice(filteredActivities.length - pageKeepSize, filteredActivities.length);
          state.nextActivityDate[action.payload.key] = newItem.nextActivityDate;
          state.nextActivityUrl[action.payload.key] = newItem.nextActivityUrl;
          state.prevActivityDate[action.payload.key] =
            filteredActivities[filteredActivities.length - pageKeepSize - 1].date_added;
          state.prevActivityUrl[action.payload.key] = `${activeWorkspace?.url ? `${activeWorkspace?.url}/` : ''}${`${
            action.payload.key === 'home'
              ? 'api/users/vod-activities/'
              : `api/channels/${action.payload.key}/activities/`
          }`}?cursor=${window.btoa(
            cursorMaker(new Date(state.prevActivityDate[action.payload.key] as string), true)
          )}&page_size=${pageSize}`;
          state.newPrevActivityId[action.payload.key] = newActivities[0].event_id;
          if (!newItem.nextActivityUrl) {
            state.newNextActivityId[action.payload.key] = newActivities[pageKeepSize - 1].event_id;
          }
          newItem.prevActivityDate = state.prevActivityDate[action.payload.key];
          newItem.prevActivityUrl = state.prevActivityUrl[action.payload.key];
        }
      } else {
        state.prevActivityDate[action.payload.key] = newItem.prevActivityDate;
        state.prevActivityUrl[action.payload.key] = newItem.prevActivityUrl;
        state.nextActivityDate[action.payload.key] = newItem.nextActivityDate;
        state.nextActivityUrl[action.payload.key] = newItem.nextActivityUrl;
      }
      newActivityPrevNextGroup.push(newItem);
      state.activityPrevNextGroup[action.payload.key] = [...newActivityPrevNextGroup].sort(
        (objA: any, objB: any) => new Date(objA.prevActivityDate).getTime() - new Date(objB.prevActivityDate).getTime()
      );
      state.allActivities[action.payload.key] = allActivities;
      state.activities[action.payload.key] = newActivities ? newActivities : filteredActivities;
    },
    loadSpecificActivities(state, action) {
      if (!state.activityPrevNextGroup[action.payload.key]) {
        state.activityPrevNextGroup[action.payload.key] = [];
      }
      if (!state.activities[action.payload.key]) {
        state.activities[action.payload.key] = [];
      }
      if (!state.allActivities[action.payload.key]) {
        state.allActivities[action.payload.key] = [];
      }
      if (action.payload.data.next_date) {
        state.nextActivityDate[action.payload.key] = action.payload.data.next_date;
        state.nextActivityUrl[action.payload.key] = action.payload.data.links.next;
      } else {
        state.nextActivityDate[action.payload.key] = null;
        state.nextActivityUrl[action.payload.key] = null;
      }

      if (action.payload.data.previous_date) {
        state.prevActivityDate[action.payload.key] = action.payload.data.previous_date;
        state.prevActivityUrl[action.payload.key] = action.payload.data.links.previous;
      } else {
        state.prevActivityDate[action.payload.key] = null;
        state.prevActivityUrl[action.payload.key] = null;
      }
      // if (groupIndex !== -1) extend the group
      const newActivityPrevNextGroup = [];
      const newlyAddedActivities = action.payload.data.results.reverse();
      state.newPrevActivityId[action.payload.key] = newlyAddedActivities?.[0]?.event_id;
      state.newNextActivityId[action.payload.key] =
        newlyAddedActivities?.[action.payload.data.results.length - 1]?.event_id;
      const newItem = {
        prevActivityDate: state.prevActivityDate[action.payload.key],
        prevActivityUrl: state.prevActivityUrl[action.payload.key],
        nextActivityDate: state.nextActivityDate[action.payload.key],
        nextActivityUrl: state.nextActivityUrl[action.payload.key]
      };
      for (let i = 0; i < state.activityPrevNextGroup[action.payload.key].length; i++) {
        if (
          ((newItem.prevActivityDate &&
            new Date(state.activityPrevNextGroup[action.payload.key][i].prevActivityDate).getTime() >=
              new Date(newItem.prevActivityDate).getTime()) ||
            !newItem.prevActivityDate) &&
          newItem.nextActivityDate &&
          new Date(state.activityPrevNextGroup[action.payload.key][i].prevActivityDate).getTime() <=
            new Date(newItem.nextActivityDate).getTime()
        ) {
          if (
            new Date(state.activityPrevNextGroup[action.payload.key][i].nextActivityDate).getTime() >
            new Date(newItem.nextActivityDate).getTime()
          ) {
            newItem.nextActivityDate = state.activityPrevNextGroup[action.payload.key][i].nextActivityDate;
            newItem.nextActivityUrl = state.activityPrevNextGroup[action.payload.key][i].nextActivityUrl;
          }
        } else if (
          ((newItem.prevActivityDate &&
            new Date(state.activityPrevNextGroup[action.payload.key][i].prevActivityDate).getTime() <
              new Date(newItem.prevActivityDate).getTime()) ||
            !state.activityPrevNextGroup[action.payload.key][i].prevActivityDate) &&
          ((newItem.prevActivityDate &&
            new Date(state.activityPrevNextGroup[action.payload.key][i].nextActivityDate).getTime() >
              new Date(newItem.prevActivityDate).getTime()) ||
            !state.activityPrevNextGroup[action.payload.key][i].nextActivityDate)
        ) {
          newItem.prevActivityDate = state.activityPrevNextGroup[action.payload.key][i].prevActivityDate;
          newItem.prevActivityUrl = state.activityPrevNextGroup[action.payload.key][i].prevActivityUrl;
          if (
            newItem.nextActivityDate &&
            new Date(newItem.nextActivityDate).getTime() <
              new Date(state.activityPrevNextGroup[action.payload.key][i].nextActivityDate).getTime()
          ) {
            newItem.nextActivityDate = state.activityPrevNextGroup[action.payload.key][i].nextActivityDate;
            newItem.nextActivityUrl = state.activityPrevNextGroup[action.payload.key][i].nextActivityUrl;
          }
        } else {
          newActivityPrevNextGroup.push(state.activityPrevNextGroup[action.payload.key][i]);
        }
      }
      const allActivities = _.uniqBy(
        [...state.allActivities[action.payload.key], ...newlyAddedActivities],
        (o) => o.event_id
      ).sort((objA: any, objB: any) => new Date(objA.date_added).getTime() - new Date(objB.date_added).getTime());
      const filteredActivities = allActivities.filter((activity: any) => {
        if (newItem.nextActivityDate && newItem.prevActivityDate) {
          return (
            new Date(activity.date_added).getTime() > new Date(newItem.prevActivityDate as string).getTime() &&
            new Date(activity.date_added).getTime() < new Date(newItem.nextActivityDate as string).getTime()
          );
        } else if (newItem.nextActivityDate) {
          return new Date(activity.date_added).getTime() < new Date(newItem.nextActivityDate as string).getTime();
        } else if (newItem.prevActivityDate) {
          return new Date(activity.date_added).getTime() > new Date(newItem.prevActivityDate as string).getTime();
        } else {
          return true;
        }
      });
      state.prevActivityDate[action.payload.key] = newItem.prevActivityDate;
      state.prevActivityUrl[action.payload.key] = newItem.prevActivityUrl;
      state.nextActivityDate[action.payload.key] = newItem.nextActivityDate;
      state.nextActivityUrl[action.payload.key] = newItem.nextActivityUrl;
      newActivityPrevNextGroup.push(newItem);
      state.activityPrevNextGroup[action.payload.key] = [...newActivityPrevNextGroup].sort(
        (objA: any, objB: any) => new Date(objA.prevActivityDate).getTime() - new Date(objB.prevActivityDate).getTime()
      );
      state.allActivities[action.payload.key] = allActivities;
      state.activities[action.payload.key] = filteredActivities;
    },
    addActivity(state, action) {
      if (!state.activities[action.payload.key]) {
        state.activities[action.payload.key] = [];
      }
      state.activities[action.payload.key] = [...state.activities[action.payload.key], action.payload.data].sort(
        (objA: any, objB: any) => new Date(objA.date_added).getTime() - new Date(objB.date_added).getTime()
      );
      if (!state.newlyAddedActivities[action.payload.key]) {
        state.newlyAddedActivities[action.payload.key] = [];
      }
      state.newlyAddedActivities[action.payload.key].push(action.payload.data);
    },
    editActivity(state, action) {
      if (!state.activities[action.payload.key]) {
        state.activities[action.payload.key] = [];
      }
      state.activities[action.payload.key] = state.activities[action.payload.key].map((activity: any) => {
        if (activity.id === action.payload.id) {
          return action.payload.data;
        }
        return activity;
      });
    },
    removeActivity(state, action) {
      if (!state.activities[action.payload.key]) {
        state.activities[action.payload.key] = [];
      }
      state.activities[action.payload.key] = state.activities[action.payload.key].filter(
        (activity: any) => activity.id !== action.payload.data
      );
      if (!state.newlyAddedActivities[action.payload.key]) {
        state.newlyAddedActivities[action.payload.key] = [];
      }
      state.newlyAddedActivities[action.payload.key] = state.newlyAddedActivities[action.payload.key].filter(
        (addedActivity: any) => addedActivity.id !== action.payload.data
      );
    },
    initNewActivity(state, action) {
      state.newlyAddedActivities[action.payload] = [];
    },
    setRecentActivityPrevNextGroup(state, action) {
      if (!state.activityPrevNextGroup[action.payload.key]) {
        state.activityPrevNextGroup[action.payload.key] = [];
      }
      const currentactivityPrevNextGroup = state.activityPrevNextGroup[action.payload.key].find(
        (group: any) => group.nextActivityDate === null
      );
      if (currentactivityPrevNextGroup) {
        state.nextActivityDate[action.payload.key] = null;
        state.nextActivityUrl[action.payload.key] = null;
        state.prevActivityDate[action.payload.key] = currentactivityPrevNextGroup.prevActivityDate;
        state.prevActivityUrl[action.payload.key] = currentactivityPrevNextGroup.prevActivityUrl;
      }
    },
    clearGroup(state, action) {
      state.activityPrevNextGroup[action.payload.key] = [];
    },
    setPageActivityLoad(state, action) {
      state.activityPageLoaded[action.payload.key] = true;
    },
    updateActivity: (state, action) => {
      if (!state.activities[action.payload.key]) {
        state.activities[action.payload.key] = [];
      }
      const { id, channels } = action.payload;
      Object.keys(state.activities).forEach((key) => {
        // Update activities for the current key
        state.activities[key] = state.activities[key].map((activity: any) => {
          // Check if the activity's content_object ID matches the provided ID
          if (activity && activity.content_object && activity.content_object.id === id) {
            // Update the channels property of the activity
            return {
              ...activity,
              content_object: {
                ...activity.content_object,
                ...action.payload.data,
                channels: channels ? channels : activity.content_object.channels
              }
            };
          }
          return activity;
        });
      });
    },
    updateChannelPlaylist: (state, action) => {
      if (!state.activities[action.payload.key]) {
        state.activities[action.payload.key] = [];
      }
      const { key, id, playlists } = action.payload;
      const activitiesForKey = state.activities[key];
      // Check if activities exist for the specified key
      if (activitiesForKey) {
        // Find and update activities with the matching video id
        state.activities[key] = activitiesForKey.map((activity: any) => {
          if (activity && activity.content_object && activity.content_object.id === id) {
            // Update the channels property of the activity
            return {
              ...activity,
              content_object: {
                ...activity.content_object,
                playlists: playlists
              }
            };
          }
          return activity;
        });
      }
    },
    resetActivitiesForChannel(state, action) {
      const { channelId } = action.payload;
      if (state.activities[channelId]) {
        state.activities[channelId] = [];
        state.nextActivityUrl[channelId] = null;
        state.prevActivityUrl[channelId] = null;
        state.nextActivityDate[channelId] = null;
        state.prevActivityDate[channelId] = null;
        state.activityPrevNextGroup[channelId] = null;
        state.newPrevActivityId[channelId] = null;
        state.newNextActivityId[channelId] = null;
        state.activityPageLoaded[channelId] = false;
      }
    },
    removeStoredActivities(state, action) {
      const { channelId, storedActivities } = action.payload;
      // Check if newlyAddedActivities exists for the given channelId
      if (state.newlyAddedActivities[channelId]) {
        const filteredActivities = state.newlyAddedActivities[channelId].filter(
          (activity: any) =>
            !storedActivities.some((storedActivity: any) => storedActivity.event_id === activity.event_id)
        );
        // Update the state immutably
        state.newlyAddedActivities[channelId] = filteredActivities;
      }
    }
  }
});

export const {
  setActivities,
  loadSpecificActivities,
  addActivity,
  editActivity,
  removeActivity,
  initNewActivity,
  setRecentActivityPrevNextGroup,
  setPageActivityLoad,
  clearGroup,
  updateActivity,
  updateChannelPlaylist,
  resetActivitiesForChannel,
  removeStoredActivities
} = activitySlice.actions;

export const activityReducer = activitySlice.reducer;
